// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/Sidebar.css */

/* Basic Sidebar Styles */
.sidebar {
    position: fixed;
    top: 0;
    left: 0; /* Initially hidden off the screen */
    height: 100vh;
    width: 220px;
    background-color: #fff;
    transition: left 0.3s ease;
    /* color: white; */
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.09);
    z-index: 1000;
    border-right: 1px solid #ddd;
    padding: 10px;
    display: flex;
    flex-direction: column;
  }
  
  .sidebar.open {
    left: 0; /* When open, move sidebar to the left */
  }
  
  .sidebar-header {
    padding: 20px;
    text-align: center;
    background-color: #444;
  }
  
  .sidebar-nav ul {
    list-style-type: none;
    padding: 0;
  }
  
  .sidebar-nav ul li {
    /* padding: 15px; */
    /* text-align: center; */
    margin-bottom: 5px;
  }
  
  .sidebar-nav ul li a {
    padding: 15px;
    color: #333;
    text-decoration: none;
    display: block;
    width: 100%;
    /* border-bottom: 1px solid #ddd; */
    transition: all 0.3s ease-in-out;
    border-radius: 5px;
    background-color: #f5f5f5;
  }
  
  .sidebar-nav ul li a:hover {
    background: #e6f2ff;
    background-color: rgba(69, 173, 0, 0.2);
    color: #49c740;
  }
  
  /* Toggle Button Styles */
  .sidebar-toggle-btn {
    display: none;
    position: absolute;
    top: 20px;
    left: 20px;
    background-color: #444;
    color: white;
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    cursor: pointer;
  }
  

  .sidebar-nav ul li.active a {
    background: #e6f2ff;
    background-color: rgba(69, 173, 0, 0.2);
    color: #49c740;
  }
  
  .sidebar-footer {
    margin-top: auto;
    padding-top: 16px;
    border-top: 1px solid #eee;
  }
  
  .sidebar-logout-btn {
    width: 100%;
    background-color: #f5f5f5;
    border: 1px solid #ddd;
    border-radius: 6px;
    padding: 12px;
    font-weight: 600;
    color: #d9534f;
    cursor: pointer;
    transition: all 0.2s ease-in-out;
  }
  
  .sidebar-logout-btn:hover {
    background-color: rgba(217, 83, 79, 0.1);
    border-color: rgba(217, 83, 79, 0.4);
  }

  /* Mobile Responsiveness: When the screen is small, show the toggle button */
  @media (max-width: 768px) {
    .sidebar-toggle-btn {
      display: block;
    }
  
    .sidebar {
      left: -250px; /* Hide the sidebar by default on mobile */
    }
  
    .sidebar.open {
      left: 0; /* Show the sidebar when open on mobile */
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/layout/sidebar.css"],"names":[],"mappings":"AAAA,oBAAoB;;AAEpB,yBAAyB;AACzB;IACI,eAAe;IACf,MAAM;IACN,OAAO,EAAE,oCAAoC;IAC7C,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,0BAA0B;IAC1B,kBAAkB;IAClB,wCAAwC;IACxC,aAAa;IACb,4BAA4B;IAC5B,aAAa;IACb,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,OAAO,EAAE,wCAAwC;EACnD;;EAEA;IACE,aAAa;IACb,kBAAkB;IAClB,sBAAsB;EACxB;;EAEA;IACE,qBAAqB;IACrB,UAAU;EACZ;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,WAAW;IACX,qBAAqB;IACrB,cAAc;IACd,WAAW;IACX,mCAAmC;IACnC,gCAAgC;IAChC,kBAAkB;IAClB,yBAAyB;EAC3B;;EAEA;IACE,mBAAmB;IACnB,uCAAuC;IACvC,cAAc;EAChB;;EAEA,yBAAyB;EACzB;IACE,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,sBAAsB;IACtB,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;EACjB;;;EAGA;IACE,mBAAmB;IACnB,uCAAuC;IACvC,cAAc;EAChB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;IACX,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,cAAc;IACd,eAAe;IACf,gCAAgC;EAClC;;EAEA;IACE,wCAAwC;IACxC,oCAAoC;EACtC;;EAEA,4EAA4E;EAC5E;IACE;MACE,cAAc;IAChB;;IAEA;MACE,YAAY,EAAE,0CAA0C;IAC1D;;IAEA;MACE,OAAO,EAAE,yCAAyC;IACpD;EACF","sourcesContent":["/* src/Sidebar.css */\n\n/* Basic Sidebar Styles */\n.sidebar {\n    position: fixed;\n    top: 0;\n    left: 0; /* Initially hidden off the screen */\n    height: 100vh;\n    width: 220px;\n    background-color: #fff;\n    transition: left 0.3s ease;\n    /* color: white; */\n    box-shadow: 0 0 10px rgba(0, 0, 0, 0.09);\n    z-index: 1000;\n    border-right: 1px solid #ddd;\n    padding: 10px;\n    display: flex;\n    flex-direction: column;\n  }\n  \n  .sidebar.open {\n    left: 0; /* When open, move sidebar to the left */\n  }\n  \n  .sidebar-header {\n    padding: 20px;\n    text-align: center;\n    background-color: #444;\n  }\n  \n  .sidebar-nav ul {\n    list-style-type: none;\n    padding: 0;\n  }\n  \n  .sidebar-nav ul li {\n    /* padding: 15px; */\n    /* text-align: center; */\n    margin-bottom: 5px;\n  }\n  \n  .sidebar-nav ul li a {\n    padding: 15px;\n    color: #333;\n    text-decoration: none;\n    display: block;\n    width: 100%;\n    /* border-bottom: 1px solid #ddd; */\n    transition: all 0.3s ease-in-out;\n    border-radius: 5px;\n    background-color: #f5f5f5;\n  }\n  \n  .sidebar-nav ul li a:hover {\n    background: #e6f2ff;\n    background-color: rgba(69, 173, 0, 0.2);\n    color: #49c740;\n  }\n  \n  /* Toggle Button Styles */\n  .sidebar-toggle-btn {\n    display: none;\n    position: absolute;\n    top: 20px;\n    left: 20px;\n    background-color: #444;\n    color: white;\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    cursor: pointer;\n  }\n  \n\n  .sidebar-nav ul li.active a {\n    background: #e6f2ff;\n    background-color: rgba(69, 173, 0, 0.2);\n    color: #49c740;\n  }\n  \n  .sidebar-footer {\n    margin-top: auto;\n    padding-top: 16px;\n    border-top: 1px solid #eee;\n  }\n  \n  .sidebar-logout-btn {\n    width: 100%;\n    background-color: #f5f5f5;\n    border: 1px solid #ddd;\n    border-radius: 6px;\n    padding: 12px;\n    font-weight: 600;\n    color: #d9534f;\n    cursor: pointer;\n    transition: all 0.2s ease-in-out;\n  }\n  \n  .sidebar-logout-btn:hover {\n    background-color: rgba(217, 83, 79, 0.1);\n    border-color: rgba(217, 83, 79, 0.4);\n  }\n\n  /* Mobile Responsiveness: When the screen is small, show the toggle button */\n  @media (max-width: 768px) {\n    .sidebar-toggle-btn {\n      display: block;\n    }\n  \n    .sidebar {\n      left: -250px; /* Hide the sidebar by default on mobile */\n    }\n  \n    .sidebar.open {\n      left: 0; /* Show the sidebar when open on mobile */\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
